import { fastHash } from '@hasher/object-hash';
import { F } from '@utils/ts';
import memoize from 'lodash/memoize';

export function memoizeWithHash<Func extends F.Function>(func: Func): Func {
  return memoize(func, fastHash);
}
